"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rivignano-teor": {
    "bc14be38": [{
      "hkey": "bcaf6dfe",
      "slug": "rivignano-teor",
      "name": "Rivignano Teor",
      "primary": true,
      "skipSearch": false
    }],
    "campomolle": [{
      "hkey": "bcaf6dfe",
      "slug": "rivignano-teor",
      "name": "Rivignano Teor",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42eb932b": [{
      "hkey": "bcaf6dfe",
      "slug": "rivignano-teor",
      "name": "Rivignano Teor",
      "primary": true,
      "skipSearch": false
    }],
    "driolassa": [{
      "hkey": "bcaf6dfe",
      "slug": "rivignano-teor",
      "name": "Rivignano Teor",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;